import { render, staticRenderFns } from "./qui-suis-je.vue?vue&type=template&id=be90856c&scoped=true&"
import script from "./qui-suis-je.vue?vue&type=script&lang=js&"
export * from "./qui-suis-je.vue?vue&type=script&lang=js&"
import style0 from "./qui-suis-je.vue?vue&type=style&index=0&id=be90856c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90856c",
  null
  
)

export default component.exports